import {
  styled,
  Container,
  ContainerPadding,
  CTA,
  TextAppearance,
  Text,
  ContainerGutter,
  ContainerWrap,
  TextAlignment,
  ContainerHorizontalAlignment,
  ThemeProvider,
} from '@volkswagen-onehub/components-core';
import { CloseHandleV2, FocusLayerSizeV2, LayerHandleV2, LayerManagerV2 } from '@volkswagen-onehub/layer-manager';

import {
  InputError,
  PoliticaPrivacidad,
  Telefono,
  MultipleCTASelection,
  KoScreen,
  LoadingScreen,
  GeneralInputWidthWrapper,
  Nombre,
  Apellido,
  Email,
} from 'src/components';
import { questionTwoOptions } from 'src/feature-app/InputsValues';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import {
  LayerManagerWrapper,
  useFeatureAppEnvironment,
  useFeatureServices,
  useOneFormContext,
  useTrackingManager,
  formatPrefix,
} from 'src/feature-app';
import { OneFormState, IdPerson } from 'src/types';

const TextAreaWrapper = styled.div`
  label {
    width: 100%;
  }
`;

const PaddingWrapper = styled.div`
`;

const NameLastNameWrapper = styled.div`
  padding-bottom: 2px;
  gap: 20px;
  display: flex;
  flex-direction: column;
  @media all and (min-width: 960px) {
    flex-direction: row;
    gap: 32px;
  }
`;

interface OneShopProps {
  idPerson?: IdPerson;
}

export const SACOneShopFields = (props: OneShopProps) => {
  const { idPerson } = props;
  const [motivoError, setMotivoError] = useState<boolean>(false);
  const [masInfoValue, setMasInfoValue] = useState(null);
  const [nameError, setNameError] = useState<boolean>(false);

  return (
    <div>
      <PaddingWrapper>
        <>
          <Field
            isRequired={true}
            emailError={nameError}
            input={
              <>
                <Text appearance={TextAppearance.headline0350}>
                  <Text bold>Confirma tus datos</Text> y te llamaremos lo antes posible
                </Text>
                <Container padding={{ top: ContainerPadding.dynamic0050, bottom: ContainerPadding.dynamic0150 }}>
                  <Text appearance={TextAppearance.copy0200}>
                    Sea cual sea tu duda, estamos aquí para ayudarte. Solo necesitamos que completes la siguiente
                    información y nos pondremos en contacto contigo.
                  </Text>
                </Container>
                <NameLastNameWrapper>
                  <GeneralInputWidthWrapper noPaddingTop>
                    <Nombre />
                  </GeneralInputWidthWrapper>
                  <GeneralInputWidthWrapper noPaddingTop>
                    <Apellido required name='surname' />
                  </GeneralInputWidthWrapper>
                  <GeneralInputWidthWrapper noPaddingTop>
                    <Email required paginaConfirmacion />
                  </GeneralInputWidthWrapper>
                </NameLastNameWrapper>
                <Telefono paginaConfirmacion={false} required={true} />
              </>
            }
          />
        </>
        <PoliticaPrivacidad color="#001E50" />
        <LastNavigation
          setMotivoError={setMotivoError}
          masInfoValue={masInfoValue}
          setNameError={setNameError}
          idPerson={idPerson}
        />
      </PaddingWrapper>
    </div>
  );
};

interface FieldProps {
  question?: string;
  input: JSX.Element;
  isRequired?: boolean;
  emailError?: boolean;
  motivoError?: boolean;
}
const Field = (props: FieldProps) => {
  const { question, input, isRequired, emailError, motivoError } = props;

  return (
    <Container
      padding={{ bottom: ContainerPadding.dynamic0150 }}
      gutter={ContainerGutter.static300}
      wrap={ContainerWrap.always}
    >
      {
        question ? (
          <Text appearance={TextAppearance.headline0250} bold>
            {question} {isRequired ? <sup>*</sup> : null}
          </Text>
        ) : null
      }

      {input}
      {emailError || motivoError ? <InputError>Necesitamos esta información para seguir</InputError> : null}
    </Container>
  );
};

interface lastNavigationsProps {
  setMotivoError: (value: boolean) => void;
  setNameError: (value: boolean) => void;
  masInfoValue?: null | string;
  idPerson?: IdPerson;
}

function LastNavigation(props: lastNavigationsProps) {
  const { setMotivoError, masInfoValue, idPerson, setNameError } = props;
  // const dispatch = useDispatch();
  const { handleShowFinalScreen, handleSubmit } = useOneFormContext();
  const { getValues, triggerValidation } = useFormContext();
  const [layerVisible, setLayerVisible] = useState<boolean>(false);
  const [koLayer, setKoLayer] = useState<LayerHandleV2<any>>(null);
  const [koScreen, setKoScreen] = useState<boolean>(false);
  const layerManager = useFeatureServices()['layer-manager'] as LayerManagerV2;
  const store = useStore();
  const env = useFeatureAppEnvironment();
  const dispatch = useDispatch();
  const trackingManager = useTrackingManager();
  const { formData } = useSelector((state: OneFormState) => state);

  //Loading and Ko layers

  const handleKoLayer = () => {
    const layer = layerManager.openFocusLayer(renderKoLayer, {}, { size: FocusLayerSizeV2.A });
    setKoLayer(layer);
  };

  const renderKoLayer = (state: any, close: CloseHandleV2<any, any>) => {
    const NoCompraTitle = 'Uy, algo ha pasado';
    const NoCompraBody = 'Por alguna razón no hemos podido enviar tu petición. ¿Lo intentamos de nuevo?';

    return (
      <LayerManagerWrapper store={store} env={env}>
        <KoScreen
          retrySubmit={retrySubmit}
          closeLayerCallback={close}
          title={NoCompraTitle}
          bodyCopy={NoCompraBody}
          isLEM={true}
        />
      </LayerManagerWrapper>
    );
  };

  const handleLoadingScreenLayer = () => {
    const layer = layerManager.openFocusLayer(renderLoadingScreen, {}, { size: FocusLayerSizeV2.A });

    return layer;
  };

  const renderLoadingScreen = (state: any, close: CloseHandleV2<any, any>) => {
    return (
      <LayerManagerWrapper store={store} env={env}>
        <LoadingScreen copy="Enviando tu petición" />
      </LayerManagerWrapper>
    );
  };



  async function handleConfirmarCita(e: any) {

    //activar o desactivar mensajes de error
    const values = await getValues();

    trackingManager.trackFormCTAClick({
      contentId: 'Confirmar',
    });

    const isValid = await triggerValidation();

    if (isValid) {
      const loadingLayer = handleLoadingScreenLayer();
      setLayerVisible(true);

      dispatch({ type: 'UPDATE_FIELDS', payload: { 'name': values.name } });
      dispatch({ type: 'UPDATE_FIELDS', payload: { 'surname': values.surname } });
      dispatch({ type: 'UPDATE_FIELDS', payload: { 'email': values.email } });
      dispatch({ type: 'UPDATE_FIELDS', payload: { 'cellphone': `${formatPrefix(values.prefix)}${values.cellphone}` } });

      dispatch({ type: 'SET_FORM_SUBMITTED', payload: true });

      const value = await handleSubmit(e);
      loadingLayer.close();

      if (value) {
        handleShowFinalScreen();
      } else {
        handleKoLayer();
      }
    }
  }

  async function retrySubmit(e: any) {
    if (koLayer) {
      koLayer.close();
    }
    setKoScreen(false);
    const loadingLayer = handleLoadingScreenLayer();
    const value = await handleSubmit(e);
    loadingLayer.close();
    if (value) {
      handleShowFinalScreen();
    } else {
      handleKoLayer();
      setKoScreen(true);
    }
  }

  useEffect(() => {
    if (!layerVisible && koScreen) setKoScreen(false);
  }, [layerVisible]);

  useEffect(() => {
    dispatch({ type: 'UPDATE_FORM_ENDED', payload: true });
  }, []);

  return (
    <>
      <CTA
        tag="button"
        type="submit"
        emphasis="primary"
        onClick={(e) => {
          e.preventDefault();
          handleConfirmarCita(e);
        }}
        stretchContent={window.innerWidth <= 560}
      >
        Confirmar
      </CTA>
    </>
  );
}
